const SEARCH_ICON = `
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
<path d="M21 21.5215L17.5001 18.0215M20 12.0215C20 16.7159 16.1944 20.5215 11.5 20.5215C6.80558 20.5215 3 16.7159 3 12.0215C3 7.32706 6.80558 3.52148 11.5 3.52148C16.1944 3.52148 20 7.32706 20 12.0215Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
</svg>
`;

export default SEARCH_ICON;
